export default "__VITE_ASSET__hR_gJfD$__"